import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[section2]',
  imports: [
    ContainerComponent
  ],
  templateUrl: './section2.component.html',
  styleUrl: './section2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    // id: 'learn-the-symptoms'
  }
})
export class Section2Component { }
